import { render, staticRenderFns } from "./VBudgets.vue?vue&type=template&id=1f9d2b4d&"
import script from "./VBudgets.vue?vue&type=script&lang=js&"
export * from "./VBudgets.vue?vue&type=script&lang=js&"
import style0 from "./VBudgets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports